<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      color="indigo"
      icon="mdi-account-group-outline"
      plural-name="Brokers"
      singular-name="Broker"
      allow-expand
      :headers="headers"
      :resource="brokerResource"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.broker"
              :error-messages="bindings.formErrors.Broker"
              label="Broker"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="brokerHistory/"
      id-field="brokerId"
      title-field="broker"
      color="indigo"
      :columns="headers"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'Brokers',

    data: () => ({
      headers: [
        {
          text: 'Broker',
          value: 'broker',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      brokerResource: new TroodyApi('broker/'),

      historyItem: null,
    }),

    methods: {
      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },
    },
  }
</script>
